<template>
  <div class="ethos-container">
    <div class="paginated-table">
      <el-table
        class="mt-4"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="Name"
          min-width="200"
          sortable
        />
        <el-table-column
          prop="uploads.originalFileName"
          label="Original File Name"
          min-width="300"
          sortable
        />
        <el-table-column
          prop="createdOn"
          label="Created On"
          width="250"
          sortable
        >
          <template slot-scope="scope">
            {{ $date(scope.row.createdOn).tz(userTimezone).format("MMM DD, YYYY [at] hh:mm a") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createdBy"
          label="Created By"
          min-width="200"
          sortable
        />
        <el-table-column
          prop="modifiedOn"
          label="Modified On"
          width="250"
          sortable
        >
          <template slot-scope="scope">
            {{ $date(scope.row.modifiedOn).tz(userTimezone).format("MMM DD, YYYY [at] hh:mm a") }}
          </template>
        </el-table-column>
        <el-table-column
          prop="modifiedBy"
          label="Modified By"
          min-width="200"
          sortable
        />
        <el-table-column
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">
            <base-button
              size="sm"
              type="primary"
              simple
              @click="handleUploadsView(scope.row.uploads.id)"
            >
              View
            </base-button>
          </template>
        </el-table-column>
      </el-table>
      <table-pagination
        ref="pagination"
        :pagination="pagination"
        @changed="handlePaginationChange"
      />
    </div>
    <!-- <download-blob
      ref="dlblob"
      :blob="dlFileBlob"
      :file-name="dlFileName"
      :content-type="dlFileContentType"
      :visible="false"
    /> -->
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {getTranscriptions} from "../../../api";
// import {downloadTranscriptions} from "../../../api";
// import {hasChildRoute} from "src/util/util";
// import {PlusIcon} from "vue-feather-icons";
// import DownloadBlob from "../DownloadBlob.vue";
import "src/assets/sass/custom/paginated-table.scss";
import {isDefined} from "../../../api/helpers";
import TablePagination from "../../../components/TablePagination.vue";

export default {
  name: "list-transcriptions",
  components: {
    // PlusIcon,
    TablePagination,
    // DownloadBlob,
  },
  props: {
    // caseId: {
    //   type: Number,
    //   default: null,
    // },
    // projectId: {
    //   type: Number,
    //   default: null,
    // },
  },
  data() {
    return {
      tableData: [],
      pagination: {
        TotalCount: 0,
      },
      // hasChildRoute: false,
      // dlFileBlob: null,
      // dlFileName: null,
      // dlFileContentType: null,
    };
  },
  computed: {
    ...mapGetters("data", [
      "getSearchKeyword",
      "userTimezone",
    ]),
  },
  // beforeRouteUpdate(to, from, next) {
  //   this.hasChildRoute = hasChildRoute(to.path, "uploads");
  //   next();
  // },
  mounted() {
    // this.hasChildRoute = hasChildRoute(
    //   this.$router.currentRoute.path,
    //   "uploads"
    // );
    this.loadTranscriptions(this.getSearchKeyword);
  },
  methods: {
    loadTranscriptions(keyword) {
      if (!this.$refs.pagination) return;
      getTranscriptions(this.$refs.pagination.pageNumber, this.$refs.pagination.pageSize, keyword)
        .then((response) => {
          this.tableData = response.data;
          this.pagination = JSON.parse(response.pagination);
          this.loading = false;
        })
        .catch((ex) => {
          this.loading = false;
          this.$notifyError("Loading Data Failed", ex);
        });
    },
    handlePaginationChange() {
      this.loadTranscriptions();
    },
    handleUploadsView(id) {
      if (!isDefined(id)) return;
      this.$router.push(`/uploads/${id}/transcript`);
    },
  },
  watch: {
    "$store.state.data.searchKeyword": function() {
      this.loadTranscriptions(this.$store.state.data.searchKeyword);
    },
  },
};
</script>
